/* Coco custom variant UI — PET version (Single Pet Portrait).
   Drives the BPO selects, updates the ATC button price directly,
   reads background colours dynamically from BPO radios, and locks the ATC
   button until pet name and background colour are filled. */
   (function () {
    var root = document.getElementById('coco-cvb');
    if (!root || root.dataset.cocoInit) return;
    root.dataset.cocoInit = '1';
  
    var DATA = window.CocoVariantPickerData || {};
    var VARS = DATA.variants || [];
    var FAVAIL = DATA.framingAvailability || [];
    var FRAMINGS = DATA.framings || [];
  
    (function () {
      var map = {
        'adBg': '--coco-ad-bg', 'adBorder': '--coco-ad-border', 'adHeading': '--coco-ad-heading',
        'adSubtext': '--coco-ad-subtext', 'adAccent': '--coco-ad-accent', 'adToggle': '--coco-ad-toggle',
        'adBoxbg': '--coco-ad-boxbg', 'adBoxborder': '--coco-ad-boxborder', 'adRemove': '--coco-ad-remove'
      };
      try {
        for (var k in map) { var v = root.dataset[k]; if (v) root.style.setProperty(map[k], v); }
      } catch (e) {}
    })();
  
    root.innerHTML =
      '<div class="cvb-lab"><span class="n">1</span> Choose your finish</div>' +
      '<div class="cvb-opt" data-f="digital"><span class="cvb-rad"></span><div><div class="t">Digital download (JPG)</div><div class="d">Print at home or anywhere</div></div><span class="cvb-oos">Sold out</span></div>' +
      '<div class="cvb-opt" data-f="3040"><span class="cvb-rad"></span><div><div class="t">30×40cm framed</div><div class="d">Oak, white or black · ready to hang</div></div><span class="pr" data-pr="3040"></span> <span class="cvb-oos">Sold out</span></div>' +
      '<div class="cvb-opt" data-f="4560"><span class="cvb-rad"></span><div><div class="t">45×60cm framed</div><div class="d">Statement size · ready to hang</div></div><span class="pr" data-pr="4560"></span> <span class="cvb-oos">Sold out</span></div>' +
      '<div class="cvb-colours" id="cvb-col"><div class="cvb-cwrap"><div class="h">Choose your frame colour</div><div class="cvb-sw">' +
      '<div class="cvb-cc" data-c="Oak"><div class="chip" style="background:#caa46f"></div>Oak<span class="cvb-oos">Sold out</span></div>' +
      '<div class="cvb-cc" data-c="White"><div class="chip" style="background:#f3f0ea"></div>White<span class="cvb-oos">Sold out</span></div>' +
      '<div class="cvb-cc" data-c="Black"><div class="chip" style="background:#2c2c2a"></div>Black<span class="cvb-oos">Sold out</span></div>' +
      '</div></div></div>' +
      '<div class="cvb-lab"><span class="n">2</span> Personalise it</div>' +
      '<label class="cvb-flab" for="coco-petname">Your pet\'s name <span class="req">· required</span></label>' +
      '<input type="text" id="coco-petname" class="cvb-input" placeholder="e.g. Bingo" autocomplete="off">' +
      '<div class="cvb-flab cvb-flab-row" style="margin-top:13px"><span>Background colour <span class="req">· required</span></span><button type="button" id="coco-bgpreview" class="cvb-preview">See each colour</button></div>' +
      '<div class="cvb-bg" id="coco-bg"></div>' +
      '<div class="cvb-bgsel">Selected: <strong id="coco-bgsel">—</strong></div>' +
      '<div class="cvb-lab"><span class="n">3</span> Need it fast?</div>' +
      '<div class="cvb-rush" id="cvb-rush"><span class="cvb-tog"><span class="k"></span></span><div style="flex:1"><div style="font-weight:600;font-size:15px">⚡ Rush order — 48 hours</div><div style="font-size:13px;color:var(--coco-bx-subtext,#8a857d)">Skip the queue, proof in 2 days</div></div><span id="cvb-rushpr" style="font-weight:600;color:var(--coco-bx-accent,#D2694A);white-space:nowrap"></span></div>';
  
    var st = { finish: 'digital', colour: 'Oak', rush: false };
    (function syncStFromVariant() {
      try {
        var vpx = document.querySelector('variant-picker');
        if (!vpx) return;
        var fr = vpx.querySelector('input[type="radio"][data-option-position="1"]:checked');
        var ru = vpx.querySelector('input[type="radio"][data-option-position="2"]:checked');
        var ftxt = '';
        if (fr) { var fl = fr.closest('label'); ftxt = (fl ? fl.textContent : fr.value).replace(/\s+/g, ' ').trim(); }
        if (ru) { var rl = ru.closest('label'); var rtxt = (rl ? rl.textContent : ru.value).replace(/\s+/g, ' ').trim(); if (/48\s*hours/i.test(rtxt)) st.rush = true; }
        if (ftxt) {
          if (/no\s*frame|digital/i.test(ftxt)) st.finish = 'digital';
          else if (/30\s*x\s*40/i.test(ftxt)) st.finish = '3040';
          else if (/45\s*x\s*60/i.test(ftxt)) st.finish = '4560';
          if (st.finish !== 'digital') {
            if (/oak/i.test(ftxt)) st.colour = 'Oak';
            else if (/white/i.test(ftxt)) st.colour = 'White';
            else if (/black/i.test(ftxt)) st.colour = 'Black';
          }
        }
      } catch (e) {}
    })();
    var vp = document.querySelector('variant-picker');
    var RUSH = 'Receive my JPG file in 48 hours or less!';
  
    // AUTO-SELECT VARIANT FROM URL PARAMETERS
    (function urlVariantOverride() {
      var params = new URLSearchParams(location.search);
      var variantId = params.get('variant');
      var selectedVariant = null;
  
      if (variantId) {
        for (var i = 0; i < VARS.length; i++) {
          if (VARS[i].id == variantId) {
            selectedVariant = VARS[i];
            break;
          }
        }
      }
  
      if (!selectedVariant) {
        var opt1 = params.get('option1');
        var opt2 = params.get('option2');
        if (opt1 && opt2) {
          var framingDecoded = decodeURIComponent(opt1).replace(/\+/g, ' ');
          var rushDecoded = decodeURIComponent(opt2).replace(/\+/g, ' ').toLowerCase();
          for (var i = 0; i < VARS.length; i++) {
            if (VARS[i].option1 === framingDecoded && VARS[i].option2 === rushDecoded) {
              selectedVariant = VARS[i];
              break;
            }
          }
        }
      }
  
      if (selectedVariant) {
        var framingStr = selectedVariant.option1;
        if (/no\s*frame|digital/i.test(framingStr)) {
          st.finish = 'digital';
          st.colour = 'Oak';
        } else {
          if (/30\s*x\s*40/i.test(framingStr)) st.finish = '3040';
          else if (/45\s*x\s*60/i.test(framingStr)) st.finish = '4560';
          if (/oak/i.test(framingStr)) st.colour = 'Oak';
          else if (/white/i.test(framingStr)) st.colour = 'White';
          else if (/black/i.test(framingStr)) st.colour = 'Black';
        }
        st.rush = (/48\s*hours/i.test(selectedVariant.option2));
        console.log('URL variant applied:', st);
      }
    })();
  
    function money(c) { return '$' + (c / 100).toFixed(2); }
    function $(s) { return root.querySelector(s); }
    function all(s) { return Array.prototype.slice.call(root.querySelectorAll(s)); }
  
    /* ========== DRIVE BPO SELECTS ========== */
    function setNative(value) {
      if (!value) return;
      var bpoSels = document.querySelectorAll('#bcpo select[name="name0"], #bcpo select[name="name1"]');
      for (var i = 0; i < bpoSels.length; i++) {
        var s = bpoSels[i];
        for (var j = 0; j < s.options.length; j++) {
          if (s.options[j].value === value || s.options[j].textContent.replace(/\s+/g, ' ').trim() === value) {
            if (s.selectedIndex !== j) {
              s.selectedIndex = j;
              s.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
        }
      }
    }
  
    function frameValOf(finish, colour) {
      if (finish === 'digital') return 'No frame (Digital Download JPG)';
      var targetSize = finish === '3040' ? '30 x 40' : '45 x 60';
      var targetColour = colour.toLowerCase();
      for (var i = 0; i < FRAMINGS.length; i++) {
        var f = FRAMINGS[i];
        if (f.indexOf(targetSize) > -1 && f.toLowerCase().indexOf(targetColour) > -1) {
          return f;
        }
      }
      if (finish === '3040') return '30 x 40cm ' + colour + ' Frame';
      return '45 x 60cm ' + colour + ' Frame (Not Available in NZ or Canada)';
    }
    function frameVal() { return frameValOf(st.finish, st.colour); }
    function isRushVal(r) { return (r || '').indexOf('48 hours') > -1; }
    function availForFrame(framingStr) {
      for (var i = 0; i < FAVAIL.length; i++) { if (FAVAIL[i].f === framingStr) return FAVAIL[i].a !== false; }
      return true;
    }
    function availFin(finish, colour, rushBool) { return availForFrame(frameValOf(finish, colour)); }
    function sizeAvail(finish, rushBool) {
      if (finish === 'digital') return availFin('digital', '', rushBool);
      var cc = ['Oak', 'White', 'Black'];
      for (var i = 0; i < cc.length; i++) { if (availFin(finish, cc[i], rushBool)) return true; }
      return false;
    }
    function normalizeSelection() {
      if (st.finish !== 'digital' && !sizeAvail(st.finish, st.rush)) { st.finish = 'digital'; }
      if (st.finish === '3040' || st.finish === '4560') {
        if (!availFin(st.finish, st.colour, st.rush)) {
          var cc = ['Oak', 'White', 'Black'];
          for (var i = 0; i < cc.length; i++) { if (availFin(st.finish, cc[i], st.rush)) { st.colour = cc[i]; break; } }
        }
      }
    }
    function rushVal() { return st.rush ? RUSH : 'No thanks'; }
  
    function apply() {
      normalizeSelection();
      setNative(frameVal());
      setNative(rushVal());
  
      var framing = frameVal();
      var rush = rushVal();
      var variantId = null;
      for (var i = 0; i < VARS.length; i++) {
        var v = VARS[i];
        if (v.option1 === framing && v.option2 === rush.toLowerCase()) {
          variantId = v.id;
          break;
        }
      }
      if (variantId) {
        var vidSelect = document.getElementById('bcpo-select');
        if (vidSelect) {
          for (var j = 0; j < vidSelect.options.length; j++) {
            if (vidSelect.options[j].value == variantId) {
              if (vidSelect.selectedIndex !== j) {
                vidSelect.selectedIndex = j;
                vidSelect.dispatchEvent(new Event('change', { bubbles: true }));
              }
              break;
            }
          }
        }
      }
  
      render();
    }
  
    function render() {
      all('.cvb-opt').forEach(function (o) { var f = o.getAttribute('data-f'); var oos = !sizeAvail(f, st.rush); o.classList.toggle('cvb-soldout', oos); o.classList.toggle('act', f === st.finish && !oos); });
      all('.cvb-cc').forEach(function (c) { var cl = c.getAttribute('data-c'); var oos = !availFin(st.finish, cl, st.rush); c.classList.toggle('cvb-soldout', oos); c.classList.toggle('act', cl === st.colour && !oos); });
      var col = $('#cvb-col');
      if (st.finish === 'digital') {
        col.classList.remove('open');
      } else {
        var card = root.querySelector('.cvb-opt[data-f="' + st.finish + '"]');
        if (card && card.nextElementSibling !== col) card.after(col);
        col.classList.add('open');
      }
      $('#cvb-rush').classList.toggle('act', st.rush);
    }
  
    all('.cvb-opt').forEach(function (o) { o.addEventListener('click', function () { if (o.classList.contains('cvb-soldout')) return; st.finish = o.getAttribute('data-f'); apply(); }); });
    all('.cvb-cc').forEach(function (c) { c.addEventListener('click', function () { if (c.classList.contains('cvb-soldout')) return; st.colour = c.getAttribute('data-c'); apply(); }); });
    $('#cvb-rush').addEventListener('click', function () { st.rush = !st.rush; apply(); });
  
    setTimeout(function() { normalizeSelection(); render(); apply(); }, 50);
  
    /* ========== PERSONALISE: PET NAME & BACKGROUND COLOUR ========== */
    var pform = (function(){var __b=document.querySelector('.product-info__buy-buttons button[type="submit"]')||document.querySelector('.product-info buy-buttons button[type="submit"]')||document.querySelector('.product-info button[type="submit"][name="add"]');var __f=__b&&__b.closest('form[action*="/cart/add"]');return __f||document.querySelector('form[action*="/cart/add"]');})();
    var __PETSK = '__cocoPetSt_' + (location.pathname || '');
    var PET = window[__PETSK] || { name: '', bg: '' };
    window[__PETSK] = PET;
    var hName = null;
    if (pform) {
      hName = document.createElement('input'); hName.type = 'hidden'; hName.name = "properties[Your pet's name]"; pform.appendChild(hName);
    }
    var nameInput = $('#coco-petname');
    var hasInteracted = false; // NEW: tracks if user has started interacting with required fields
  
    if (nameInput) {
      if (PET.name) { nameInput.value = PET.name; if (hName) hName.value = PET.name; }
      nameInput.addEventListener('input', function () { 
        PET.name = nameInput.value; 
        if (hName) hName.value = nameInput.value; 
        hasInteracted = true;
        // clear error style when typing
        nameInput.classList.remove('cvb-err');
        updateATCButtonState(); 
      });
      nameInput.addEventListener('blur', function () {
        hasInteracted = true;
        if (!nameInput.value.trim()) {
          nameInput.classList.add('cvb-err');
        } else {
          nameInput.classList.remove('cvb-err');
        }
        updateATCButtonState();
      });
    }
  
    /* ========== BACKGROUND COLOUR (BPO + DATA-BG IMAGES) ========== */
    var bgWrap = $('#coco-bg'), bgSel = $('#coco-bgsel');
    var bgChips = [];
  
    var bgImageMap = {};
    try {
      var rawBg = root.dataset.bg;
      if (rawBg) {
        var parsed = JSON.parse(rawBg);
        (parsed || []).forEach(function (item) {
          var key = item.n || item.name || '';
          if (key) bgImageMap[key] = item.img || '';
        });
      }
    } catch (e) {}
  
    function extractColourFromLabel(radio) {
      var label = radio.closest('label');
      if (!label) return '#cccccc';
      var style = label.getAttribute('style') || '';
      var match = style.match(/background\s*:\s*([^;]+)/i);
      if (match && match[1]) {
        var val = match[1].trim();
        if (val.indexOf('#') !== -1 || val.indexOf('rgb') !== -1) return val;
      }
      var match2 = style.match(/background-color\s*:\s*([^;]+)/i);
      if (match2 && match2[1]) return match2[1].trim();
      return '#cccccc';
    }
  
    function refreshBgData() {
      var radios = document.querySelectorAll(
        'input[name="properties[Background Colour]"], input[name="properties[Background]"]'
      );
      bgChips = [];
      Array.prototype.forEach.call(radios, function (radio) {
        var name = radio.value;
        var colour = extractColourFromLabel(radio);
        var img = bgImageMap[name] || bgImageMap[name.toLowerCase()] || '';
        bgChips.push({ name: name, colour: colour, img: img });
      });
    }
  
    function fallbackFromDataBg() {
      try {
        var raw = root.dataset.bg;
        if (raw) {
          var parsed = JSON.parse(raw);
          if (parsed && parsed.length) {
            bgChips = parsed.map(function (item) {
              return {
                name: item.n || item.name || '',
                colour: item.h || item.colour || '#cccccc',
                img: item.img || ''
              };
            });
            return true;
          }
        }
      } catch (e) {}
      return false;
    }
  
    function buildChips() {
      if (!bgWrap) return;
      bgWrap.innerHTML = '';
      if (!bgChips.length) {
        var msg = document.createElement('div');
        msg.textContent = 'No colours yet…';
        bgWrap.appendChild(msg);
        return;
      }
      bgChips.forEach(function (c) {
        var chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'cvb-chip';
        chip.setAttribute('data-c', c.name);
        if (c.img) chip.setAttribute('data-img', c.img);
        chip.title = c.name;
        chip.setAttribute('aria-label', c.name);
        chip.style.background = c.colour;
        chip.style.display = 'inline-block';
        chip.style.width = '36px';
        chip.style.height = '36px';
        chip.style.borderRadius = '50%';
        chip.style.border = '2px solid #cccccc';
        chip.style.cursor = 'pointer';
        chip.style.padding = '0';
        chip.addEventListener('click', function () { selectColour(c.name); });
        bgWrap.appendChild(chip);
      });
    }
  
    function selectColour(name) {
      var radio = document.querySelector(
        'input[name="properties[Background Colour]"][value="' + name.replace(/"/g, '\\"') + '"], ' +
        'input[name="properties[Background]"][value="' + name.replace(/"/g, '\\"') + '"]'
      );
      if (radio) {
        radio.disabled = false;
        radio.checked = true;
      }
      PET.bg = name;
      hiddenBgInput.value = name;
      hasInteracted = true;
      if (bgSel) bgSel.textContent = name;
      if (bgWrap) {
        bgWrap.classList.remove('cvb-err');
        Array.prototype.forEach.call(bgWrap.children, function (chip) {
          var isSelected = chip.getAttribute('data-c') === name;
          chip.classList.toggle('act', isSelected);
          chip.style.borderColor = isSelected ? '#000000' : '#cccccc';
        });
      }
      var popup = document.getElementById('coco-bgpreview');
      if (popup && popup.classList.contains('open')) {
        Array.prototype.forEach.call(popup.querySelectorAll('.pv-tile'), function (tile) {
          tile.classList.toggle('sel', tile.getAttribute('data-c') === name);
        });
      }
      updateATCButtonState();
    }
  
    var retries = 0;
    function initBgColour() {
      refreshBgData();
      if (bgChips.length === 0) {
        if (fallbackFromDataBg()) {
          buildChips();
          if (PET.bg) selectColour(PET.bg);
          return;
        }
        if (retries < 40) {
          retries++;
          setTimeout(initBgColour, 200);
          return;
        }
      }
      buildChips();
      if (PET.bg) selectColour(PET.bg);
    }
    initBgColour();
  
    var hiddenBgInput = document.createElement('input');
    hiddenBgInput.type = 'hidden';
    hiddenBgInput.name = 'properties[Background Colour]';
    if (pform) {
      pform.appendChild(hiddenBgInput);
    } else {
      root.appendChild(hiddenBgInput);
    }
    if (PET.bg) hiddenBgInput.value = PET.bg;
  
    // "See each colour" popup
    (function () {
      function initPopup() {
        var labRow = document.querySelector('#coco-cvb .cvb-flab-row');
        if (!labRow || document.getElementById('coco-bgpv-open')) return false;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.id = 'coco-bgpv-open';
        btn.className = 'cvb-preview';
        btn.textContent = 'See each colour';
        labRow.appendChild(btn);
  
        var stl = document.createElement('style');
        stl.textContent =
          '#coco-bgpreview{position:fixed;inset:0;z-index:99999;display:none;align-items:center;justify-content:center;background:rgba(28,28,26,.55);padding:18px;}' +
          '#coco-bgpreview.open{display:flex;}' +
          '#coco-bgpreview .pv-panel{background:var(--coco-bx-panel-bg,#FBF8F2);border-radius:16px;max-width:760px;width:100%;max-height:90vh;overflow:auto;padding:20px 20px 24px;box-shadow:0 12px 50px rgba(0,0,0,.35);}' +
          '#coco-bgpreview .pv-head{display:flex;align-items:center;justify-content:space-between;margin-bottom:14px;}' +
          '#coco-bgpreview .pv-head h3{margin:0;font-family:var(--heading-font-family,inherit);color:var(--coco-bx-heading,#2A555A);font-size:19px;}' +
          '#coco-bgpreview .pv-x{background:none;border:0;font-size:26px;line-height:1;color:var(--coco-bx-subtext,#8a857d);cursor:pointer;padding:0 4px;}' +
          '#coco-bgpreview .pv-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(120px,1fr));gap:12px;}' +
          '#coco-bgpreview .pv-tile{border:2px solid transparent;border-radius:12px;overflow:hidden;cursor:pointer;background:#fff;padding:0;text-align:center;}' +
          '#coco-bgpreview .pv-tile img{width:100%;display:block;aspect-ratio:81/144;object-fit:cover;}' +
          '#coco-bgpreview .pv-tile .nm{display:block;font-size:12.5px;font-weight:600;color:#2c2c2a;padding:7px 6px;}' +
          '#coco-bgpreview .pv-tile.sel{border-color:var(--coco-bx-heading,#2A555A);}' +
          '#coco-bgpreview .pv-tile:hover{border-color:var(--coco-bx-accent,#D2694A);}';
        document.head.appendChild(stl);
  
        var ov = document.createElement('div');
        ov.id = 'coco-bgpreview';
        function renderTiles() {
          var tilesHTML = bgChips.map(function (c) {
            if (c.img) {
              return '<button type="button" class="pv-tile" data-c="' + c.name + '">' +
                     '<img loading="lazy" src="' + c.img + '" alt="' + c.name + ' background" style="width:100%;display:block;aspect-ratio:81/144;object-fit:cover;">' +
                     '<span class="nm">' + c.name + '</span></button>';
            } else {
              return '<button type="button" class="pv-tile" data-c="' + c.name + '">' +
                     '<div class="swatch" style="background:' + c.colour + '; height:100px; border-radius:8px; margin-bottom:8px;"></div>' +
                     '<span class="nm">' + c.name + '</span></button>';
            }
          }).join('');
          ov.innerHTML =
            '<div class="pv-panel"><div class="pv-head">' +
            '<h3>See it in every background</h3>' +
            '<button type="button" class="pv-x" aria-label="Close">&times;</button></div>' +
            '<div class="pv-grid">' + tilesHTML + '</div></div>';
        }
        renderTiles();
        document.body.appendChild(ov);
  
        function close() { ov.classList.remove('open'); }
        function open() {
          renderTiles();
          Array.prototype.forEach.call(ov.querySelectorAll('.pv-tile'), function (t) {
            t.classList.toggle('sel', t.getAttribute('data-c') === (PET.bg || ''));
          });
          ov.classList.add('open');
        }
  
        btn.addEventListener('click', open);
        ov.addEventListener('click', function (e) {
          if (e.target === ov || e.target.classList.contains('pv-x')) { close(); return; }
          var tile = e.target.closest('.pv-tile');
          if (tile) {
            selectColour(tile.getAttribute('data-c'));
            close();
          }
        });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
        return true;
      }
  
      if (!initPopup()) {
        var tries = 0;
        var iv = setInterval(function () { tries++; if (initPopup() || tries > 40) clearInterval(iv); }, 250);
      }
    })();
  
      /* ========== ATC BUTTON LOCK (NAME + BG + UPLOAD) ========== */
    var submitAttempted = false;
  
    function getATCButton() {
      return (pform && (pform.querySelector('button[type="submit"]') ||
                        pform.querySelector('input[type="submit"]'))) ||
             document.querySelector('.product-info button[type="submit"]') ||
             document.querySelector('button[name="add"]') ||
             document.querySelector('button[type="submit"]');
    }
  
    // Check coco-photo-upload (preferred) or legacy UploadKit hidden field
    function isUploadedImageSet() {
      if (window.__cocoUploadedFile) return true;
      var wrap = document.getElementById('coco-photo-upload');
      if (wrap) {
        if (wrap.classList.contains('coco-upload-invalid')) return false;
        var fileInput = document.getElementById('coco-photo-input') ||
          wrap.querySelector('input[type="file"][name="properties[Uploaded image]"]');
        if (fileInput && fileInput.files && fileInput.files.length > 0) return true;
        return !wrap.classList.contains('coco-upload-invalid');
      }
      var legacy = document.getElementById('uploaded-image-hidden');
      if (legacy && legacy.value.trim().length > 0) return true;
      var input = document.querySelector('input[name="properties[Uploaded image]"]');
      if (!input) return false;
      if (input.type === 'file') return !!(input.files && input.files.length);
      return input.value.trim().length > 0;
    }
  
    function areFieldsValid() {
      var nameOk = nameInput && nameInput.value.trim().length > 0;
      var bgOk = PET.bg && PET.bg.length > 0;
      var imageOk = isUploadedImageSet();
      return nameOk && bgOk && imageOk;
    }
  
    function getMissingFieldsEl() {
      var el = document.getElementById('coco-missing-fields');
      if (!el) {
        el = document.createElement('div');
        el.id = 'coco-missing-fields';
      }
      var anchor = document.getElementById('coco-photo-upload');
      if (anchor && anchor.parentNode) {
        if (anchor.nextSibling !== el) {
          anchor.parentNode.insertBefore(el, anchor.nextSibling);
        }
      } else if (!el.parentNode) {
        var btn = getATCButton();
        var container = btn ? (btn.closest('buy-buttons') || btn.closest('.product-info__buy-buttons') || btn) : null;
        if (container && container.parentNode) {
          container.parentNode.insertBefore(el, container);
        } else {
          document.body.appendChild(el);
        }
      }
      return el;
    }
  
    function updateATCButtonState() {
      var btn = getATCButton();
      if (!btn) return;
  
      var missing = [];
  
      if (!nameInput.value.trim()) {
        missing.push("your pet's name");
        nameInput.classList.add('cvb-err');
      } else {
        nameInput.classList.remove('cvb-err');
      }
  
      if (!PET.bg) {
        missing.push("a background colour");
        if (bgWrap) bgWrap.classList.add('cvb-err');
      } else {
        if (bgWrap) bgWrap.classList.remove('cvb-err');
      }
  
      if (!isUploadedImageSet()) {
        missing.push("an uploaded image");
      }
  
      var valid = missing.length === 0;
  
      btn.disabled = !valid;
      btn.classList.toggle('coco-atc-locked', !valid);
  
      var msgEl = getMissingFieldsEl();
  
      // Show error message if user has already interacted and something is missing,
      // or if they tried to submit.
      if ((hasInteracted || submitAttempted) && !valid) {
        msgEl.innerHTML =
          "⚠️ Before we can add this to your cart, please complete " +
          missing.join(", ") +
          ".";
        msgEl.classList.add('visible');
      } else {
        msgEl.classList.remove('visible');
      }
    }
  
    function interceptClick(e) {
      var btn = getATCButton();
      if (btn && (btn.disabled || btn.classList.contains('coco-atc-locked'))) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        submitAttempted = true;
        updateATCButtonState();
      }
    }
  
    (function disableButtonInitially() {
      var buyWrapper = document.querySelector('.product-info buy-buttons');
      if (buyWrapper) {
        buyWrapper.addEventListener('click', function(e) {
          var btn = getATCButton();
          if (btn && (btn.disabled || btn.classList.contains('coco-atc-locked'))) {
            e.preventDefault();
            e.stopPropagation();
            submitAttempted = true;
            updateATCButtonState();
          }
        }, true);
      }
      function disable() {
        var btn = getATCButton();
        if (btn) {
          btn.disabled = true;
          btn.setAttribute('disabled', '');
          btn.classList.add('coco-atc-locked');
          btn.addEventListener('click', interceptClick, true);
          observeButtonForChanges(btn);
        } else {
          setTimeout(disable, 50);
        }
      }
  
      function observeButtonForChanges(btn) {
        var observer = new MutationObserver(function (mutations) {
          if (!btn.disabled && !btn.hasAttribute('disabled')) {
            btn.disabled = true;
            btn.setAttribute('disabled', '');
            btn.classList.add('coco-atc-locked');
          }
          if (!btn.classList.contains('coco-atc-locked')) {
            btn.classList.add('coco-atc-locked');
          }
        });
        observer.observe(btn, { attributes: true, attributeFilter: ['disabled', 'class'] });
        setTimeout(function () { observer.disconnect(); }, 30000);
      }
  
      disable();
    })();
  
    /* ========== CART PROPERTIES + UPLOAD (same flow as people) ========== */
    // Flow: select photo FIRST → ATC → multipart cart/add with file → redirect to /cart
    function ensureProductFormId(form) {
      if (!form) return '';
      if (!form.id) form.id = 'coco-pet-product-form';
      return form.id;
    }

    function getUploadedFile() {
      if (window.__cocoUploadedFile) return window.__cocoUploadedFile;
      var photoInput = document.getElementById('coco-photo-input');
      if (photoInput && photoInput.files && photoInput.files[0]) return photoInput.files[0];
      return null;
    }

    function getVariantIdFromForm(form) {
      form = form || pform;
      if (!form) return '';
      var idInput = form.querySelector('[name="id"]');
      return idInput && idInput.value ? String(idInput.value) : '';
    }

    function bindCartProperties(form) {
      form = form || pform;
      if (!form) return false;
      var formId = ensureProductFormId(form);

      // Pet name
      if (hName) {
        hName.name = "properties[Your pet's name]";
        hName.setAttribute('form', formId);
        if (nameInput) hName.value = nameInput.value.trim();
      }

      // Background Colour (pet property name)
      if (hiddenBgInput) {
        hiddenBgInput.name = 'properties[Background Colour]';
        hiddenBgInput.setAttribute('form', formId);
        if (PET.bg) hiddenBgInput.value = PET.bg;
      }

      // Uploaded image file
      var photoInput = document.getElementById('coco-photo-input') ||
        document.querySelector('#coco-photo-upload input[type="file"]');
      if (photoInput) {
        photoInput.name = 'properties[Uploaded image]';
        photoInput.setAttribute('form', formId);
        if (window.__cocoUploadedFile && !(photoInput.files && photoInput.files.length)) {
          try {
            var dt = new DataTransfer();
            dt.items.add(window.__cocoUploadedFile);
            photoInput.files = dt.files;
          } catch (err) {}
        }
      }
      var photoWrap = document.getElementById('coco-photo-upload');
      if (photoWrap) photoWrap.setAttribute('data-form-id', formId);

      Array.prototype.forEach.call(
        document.querySelectorAll('input[name="properties[Uploaded image]"]'),
        function (el) {
          if (el === photoInput) return;
          if (el.type === 'file') return;
          el.removeAttribute('name');
          el.disabled = true;
          el.value = '';
        }
      );

      return true;
    }

    function buildCartAddFormData(form) {
      form = form || pform;
      bindCartProperties(form);
      var fd = form ? new FormData(form) : new FormData();
      var file = getUploadedFile();
      var variantId = getVariantIdFromForm(form);
      if (variantId) fd.set('id', variantId);
      if (!fd.get('quantity')) fd.set('quantity', '1');
      var petName = (nameInput && nameInput.value.trim()) || PET.name || '';
      if (petName) fd.set("properties[Your pet's name]", petName);
      if (PET.bg) fd.set('properties[Background Colour]', PET.bg);
      if (file) fd.set('properties[Uploaded image]', file, file.name || 'upload.jpg');
      return fd;
    }

    function goToCartPage() {
      var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      window.location.href = rootUrl + 'cart';
    }

    var __cocoPetAdding = false;
    function addToCartWithUpload(form, triggerBtn) {
      if (__cocoPetAdding) return Promise.resolve();
      if (window.__cocoPetValidate && window.__cocoPetValidate() === false) {
        return Promise.resolve(false);
      }
      var file = getUploadedFile();
      if (!file && document.getElementById('coco-photo-upload')) {
        submitAttempted = true;
        updateATCButtonState();
        return Promise.resolve(false);
      }
      __cocoPetAdding = true;
      if (triggerBtn) {
        triggerBtn.setAttribute('aria-busy', 'true');
        triggerBtn.classList.add('is-loading');
      }
      var fd = buildCartAddFormData(form);
      var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return fetch(rootUrl + 'cart/add.js', {
        method: 'POST',
        body: fd,
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      }).then(function (res) {
        if (!res.ok) return res.json().catch(function () { return {}; }).then(function (err) {
          throw err;
        });
        return res.json();
      }).then(function () {
        goToCartPage();
        return true;
      }).catch(function (err) {
        console.warn('[coco-pet] cart/add with upload failed', err);
        alert((err && (err.description || err.message)) || 'Could not add to cart. Please try again.');
        __cocoPetAdding = false;
        if (triggerBtn) {
          triggerBtn.removeAttribute('aria-busy');
          triggerBtn.classList.remove('is-loading');
        }
        return false;
      });
    }

    if (pform) {
      bindCartProperties(pform);
      setTimeout(function () { bindCartProperties(pform); }, 500);
      setTimeout(function () { bindCartProperties(pform); }, 1500);
    }

    if (!window.__cocoPetCartFetchHook) {
      window.__cocoPetCartFetchHook = 1;
      var _cocoPetFetch = window.fetch;
      if (typeof _cocoPetFetch === 'function') {
        window.fetch = function (input, init) {
          try {
            var url = typeof input === 'string' ? input : (input && input.url) || '';
            if (/\/cart\/add/.test(url) && document.getElementById('coco-cvb') && document.getElementById('coco-photo-upload')) {
              bindCartProperties(pform);
              init = init ? Object.assign({}, init) : {};
              var file = getUploadedFile();
              var body = init.body;
              var isFD = typeof FormData !== 'undefined' && body instanceof FormData;
              var ct = '';
              if (init.headers) {
                if (typeof Headers !== 'undefined' && init.headers instanceof Headers) {
                  ct = init.headers.get('Content-Type') || init.headers.get('content-type') || '';
                } else if (typeof init.headers === 'object') {
                  ct = init.headers['Content-Type'] || init.headers['content-type'] || '';
                }
              }
              var isJson = /application\/json/i.test(ct) ||
                (typeof body === 'string' && /^\s*\{/.test(body));
              var petName = (nameInput && nameInput.value.trim()) || PET.name || '';

              if (isFD) {
                if (petName) body.set("properties[Your pet's name]", petName);
                if (PET.bg) body.set('properties[Background Colour]', PET.bg);
                if (file) body.set('properties[Uploaded image]', file, file.name || 'upload.jpg');
                init.body = body;
              } else if (file && isJson) {
                var data = {};
                try { data = typeof body === 'string' ? JSON.parse(body) : (body || {}); } catch (e1) { data = {}; }
                var fd = new FormData();
                var item = data.items && data.items[0] ? data.items[0] : data;
                if (item.id) fd.append('id', String(item.id));
                else {
                  var vid = getVariantIdFromForm(pform);
                  if (vid) fd.append('id', vid);
                }
                fd.append('quantity', String(item.quantity != null ? item.quantity : 1));
                var props = item.properties || data.properties || {};
                Object.keys(props).forEach(function (k) {
                  if (k === 'Uploaded image') return;
                  fd.append('properties[' + k + ']', props[k] == null ? '' : String(props[k]));
                });
                if (petName) fd.append("properties[Your pet's name]", petName);
                if (PET.bg) fd.append('properties[Background Colour]', PET.bg);
                fd.append('properties[Uploaded image]', file, file.name || 'upload.jpg');
                init.body = fd;
                if (init.headers) {
                  var h = init.headers;
                  if (typeof Headers !== 'undefined' && h instanceof Headers) {
                    h = new Headers(h);
                    h.delete('Content-Type');
                    init.headers = h;
                  } else if (h && typeof h === 'object') {
                    h = Object.assign({}, h);
                    delete h['Content-Type'];
                    delete h['content-type'];
                    init.headers = h;
                  }
                }
              }
            }
          } catch (e2) {}
          return _cocoPetFetch.call(this, input, init);
        };
      }
    }

    // Watch photo upload + legacy hidden field
    (function observeUpload() {
      document.addEventListener('coco:photo-selected', function () {
        hasInteracted = true;
        bindCartProperties(pform);
        updateATCButtonState();
      });
      document.addEventListener('coco:photo-cleared', function () {
        hasInteracted = true;
        bindCartProperties(pform);
        updateATCButtonState();
      });

      var target = document.getElementById('uploaded-image-hidden');
      if (target) {
        var lastValue = target.value;
        setInterval(function () {
          if (lastValue !== target.value) {
            lastValue = target.value;
            hasInteracted = true;
            updateATCButtonState();
          }
        }, 200);
      }
      updateATCButtonState();
    })();
  
    window.__cocoPetValidate = function () {
      submitAttempted = true;
      bindCartProperties(pform);
      if (!areFieldsValid()) {
        if (nameInput && !nameInput.value.trim().length) {
          nameInput.classList.add('cvb-err');
          try { nameInput.scrollIntoView({ block: 'center' }); } catch (_e) {}
        }
        if (!PET.bg && bgWrap) {
          bgWrap.classList.add('cvb-err');
          try { bgWrap.scrollIntoView({ block: 'center' }); } catch (_e2) {}
        }
        if (!isUploadedImageSet()) {
          var photo = document.getElementById('coco-photo-upload');
          if (photo) {
            photo.classList.add('cu-show-err');
            try { photo.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (_e3) {}
            photo.style.boxShadow = '0 0 0 3px #D2694A';
            photo.style.borderRadius = '12px';
            setTimeout(function () { photo.style.boxShadow = ''; }, 3000);
          } else {
            var field = document.getElementById('uploaded-image-hidden');
            if (field) try { field.scrollIntoView({ block: 'center' }); } catch (_e4) {}
          }
        }
        updateATCButtonState();
        return false;
      }
      submitAttempted = false;
      updateATCButtonState();
      return true;
    };

    // Intercept ATC when coco-photo-upload is present → multipart add → /cart
    if (!window.__cocoPetUploadAtcHook) {
      window.__cocoPetUploadAtcHook = 1;
      document.addEventListener('click', function (e) {
        if (!document.getElementById('coco-cvb') || !document.getElementById('coco-photo-upload')) return;
        var btn = e.target && e.target.closest && e.target.closest(
          'button[type="submit"][name="add"], buy-buttons button[type="submit"], .product-info button[type="submit"], button[name="add"]'
        );
        if (!btn) return;
        var form = btn.closest('form[action*="/cart/add"]') || pform;
        if (!form) return;
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        addToCartWithUpload(form, btn);
      }, true);

      document.addEventListener('submit', function (e) {
        var f = e.target;
        if (!f || !f.getAttribute) return;
        if (String(f.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
        if (!document.getElementById('coco-cvb')) return;
        if (document.getElementById('coco-photo-upload')) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          bindCartProperties(f);
          addToCartWithUpload(f, f.querySelector('[type="submit"]'));
          return;
        }
        if (window.__cocoPetValidate && window.__cocoPetValidate() === false) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);
    } else if (!window.__cocoPetSubmitHook) {
      window.__cocoPetSubmitHook = 1;
      document.addEventListener('submit', function (e) {
        var f = e.target;
        if (!f || !f.getAttribute) return;
        if (String(f.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
        if (!document.getElementById('coco-cvb')) return;
        if (window.__cocoPetValidate && window.__cocoPetValidate() === false) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);
    }
  
    // Price deltas from root dataset
    function cvNum(s){ if(!s) return NaN; var t=String(s).replace(/<[^>]*>/g,'').replace(/[^\d.,]/g,''); if(!t) return NaN; if(t.indexOf(',')>-1&&t.indexOf('.')>-1){ if(t.lastIndexOf(',')>t.lastIndexOf('.')){t=t.replace(/\./g,'').replace(',','.');}else{t=t.replace(/,/g,'');} } else if(t.indexOf(',')>-1){ var p=t.split(','); t=(p[p.length-1].length===2)?t.replace(/,/g,'.'):t.replace(/,/g,''); } return parseFloat(t); }
    function cvSym(s){ var m=s?String(s).replace(/<[^>]*>/g,'').trim().match(/^[^\d.,\s]+/):null; return m?m[0]:'$'; }
    function setDelta(sel, val) { var e = $(sel); if (!e || !val) return; var n = cvNum(val); if (!isFinite(n)) { e.textContent = ''; return; } e.textContent = '+' + cvSym(val) + Math.round(n); }
    setDelta('[data-pr="3040"]', root.dataset.d3040);
    setDelta('[data-pr="4560"]', root.dataset.d4560);
    setDelta('#cvb-rushpr', root.dataset.drush);
  
    /* ========== ATC PRICE UPDATE ========== */
    function updateATCPrice() {
      var variant = null;
      var framing = frameVal();
      var rush = rushVal();
      for (var i = 0; i < VARS.length; i++) {
        var v = VARS[i];
        if (v.option1 === framing && v.option2 === rush.toLowerCase()) {
          variant = v;
          break;
        }
      }
      if (!variant) return;
  
      var addBtn = getATCButton();
      if (!addBtn) return;
  
      var sym = (DATA.currencySymbol || '$').replace(/<[^>]*>/g, '').trim();
      var formatMoney = function(cents) {
        var num = (cents / 100).toFixed(2);
        var parts = num.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return sym + parts.join('.');
      };
  
      var priceCents = variant.price;
      var compareCents = variant.compare_at_price || null;
  
      var lbl = addBtn.querySelector('.coco-btn-price');
      if (!lbl) {
        lbl = document.createElement('span');
        lbl.className = 'coco-btn-price';
        addBtn.appendChild(lbl);
      }
      lbl.innerHTML = '<span class="bp-cur">' + formatMoney(priceCents) + '</span>' +
                      (compareCents && compareCents > priceCents
                        ? ' <span class="bp-was">' + formatMoney(compareCents) + '</span>'
                        : '');
  
      var saveEl = document.getElementById('coco-atc-savings');
      if (!saveEl) {
        saveEl = document.createElement('div');
        saveEl.id = 'coco-atc-savings';
        var container = addBtn.closest('buy-buttons') || addBtn.closest('.product-info__buy-buttons') || addBtn.parentElement;
        if (container) {
          container.parentNode.insertBefore(saveEl, container.nextSibling);
        } else {
          addBtn.parentNode.insertBefore(saveEl, addBtn.nextSibling);
        }
      }
  
      if (compareCents && compareCents > priceCents) {
        var saved = compareCents - priceCents;
        var pct = Math.round((saved / compareCents) * 100);
        saveEl.style.display = 'block';
        saveEl.innerHTML = 'You save <strong>' + formatMoney(saved) + '</strong> (' + pct + '%) today';
        addBtn.classList.add('has-savings');
      } else {
        saveEl.style.display = 'none';
        saveEl.innerHTML = '';
        addBtn.classList.remove('has-savings');
      }
    }
  
    function initPrice() {
      if (getATCButton()) {
        updateATCPrice();
      } else {
        setTimeout(initPrice, 50);
      }
    }
  
    var originalApply = apply;
    apply = function() {
      originalApply();
      updateATCPrice();
    };
    window.apply = apply;
  
    initPrice();
  
    // Neutralise VOPO fields
    function killVopo() {
      var hit = false;
      Array.prototype.forEach.call(document.querySelectorAll('.bcpo input, .bcpo textarea, .bcpo select'), function (el) {
        if (!el.disabled) { el.disabled = true; hit = true; }
      });
      return hit;
    }
    killVopo();
    var vmo = new MutationObserver(killVopo);
    vmo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { vmo.disconnect(); }, 15000);
  
    // Payment method icons
    (function () {
      var pinfo = document.querySelector('.product-info') || document;
      var bb = pinfo.querySelector('buy-buttons') || pinfo.querySelector('button[type="submit"]');
      if (!bb || document.getElementById('coco-pay')) return;
      var PAY = [
        { n: 'Visa', s: '<svg viewBox="0 0 48 16"><text x="24" y="13" font-family="Arial,Helvetica,sans-serif" font-weight="800" font-style="italic" font-size="15" fill="#1A1F71" text-anchor="middle" letter-spacing="1">VISA</text></svg>' },
        { n: 'Mastercard', s: '<svg viewBox="0 0 40 24"><circle cx="15.5" cy="12" r="8" fill="#EB001B"/><circle cx="24.5" cy="12" r="8" fill="#F79E1B"/><path d="M20 5.6a8 8 0 0 0 0 12.8 8 8 0 0 0 0-12.8z" fill="#FF5F00"/></svg>' },
        { n: 'American Express', c: 'amex', s: '<svg viewBox="0 0 48 14"><text x="24" y="11.5" font-family="Arial,Helvetica,sans-serif" font-weight="700" font-size="9" fill="#fff" text-anchor="middle" letter-spacing="1">AMEX</text></svg>' },
        { n: 'Discover', s: '<svg viewBox="0 0 80 16"><text x="2" y="13" font-family="Arial,Helvetica,sans-serif" font-weight="700" font-size="12" fill="#231F20">discover</text><circle cx="72" cy="9" r="6" fill="#FF6000"/></svg>' },
        { n: 'Apple Pay', c: 'applepay', s: '<svg viewBox="0 0 56 22"><path d="M11.9 6.6c-.6.7-1.5 1.2-2.3 1.1-.1-.9.3-1.8.8-2.3.6-.7 1.5-1.2 2.3-1.2.1.9-.3 1.7-.8 2.4zM12.7 7.9c-1.2-.07-2.3.7-2.9.7-.6 0-1.5-.68-2.5-.66-1.28.02-2.46.74-3.12 1.88-1.32 2.3-.34 5.7.95 7.57.63.9 1.38 1.92 2.36 1.89.95-.04 1.31-.61 2.46-.61 1.14 0 1.46.61 2.46.59 1.02-.02 1.66-.92 2.28-1.84.72-1.05 1.02-2.07 1.04-2.13-.02-.01-1.99-.77-2.01-3.02-.02-1.88 1.54-2.78 1.61-2.83-.88-1.3-2.25-1.45-2.73-1.49z" fill="#fff"/><text x="22" y="16" font-family="Arial,Helvetica,sans-serif" font-weight="600" font-size="13" fill="#fff">Pay</text></svg>' },
        { n: 'Google Pay', s: '<svg viewBox="0 0 56 20"><text x="2" y="15" font-family="Arial,Helvetica,sans-serif" font-weight="700" font-size="14" fill="#4285F4">G</text><text x="15" y="15" font-family="Arial,Helvetica,sans-serif" font-weight="500" font-size="13" fill="#5F6368">Pay</text></svg>' },
        { n: 'Shop Pay', c: 'shoppay', s: '<svg viewBox="0 0 70 18"><text x="35" y="14" font-family="Arial,Helvetica,sans-serif" font-weight="700" font-size="12.5" fill="#fff" text-anchor="middle">shop Pay</text></svg>' },
        { n: 'PayPal', s: '<svg viewBox="0 0 58 16"><text x="2" y="13" font-family="Arial,Helvetica,sans-serif" font-weight="800" font-style="italic" font-size="13" fill="#003087">Pay</text><text x="26" y="13" font-family="Arial,Helvetica,sans-serif" font-weight="800" font-style="italic" font-size="13" fill="#009CDE">Pal</text></svg>' },
        { n: 'Afterpay', s: '<svg viewBox="0 0 70 16"><text x="2" y="13" font-family="Arial,Helvetica,sans-serif" font-weight="700" font-size="12.5" fill="#000">after</text><text x="36" y="13" font-family="Arial,Helvetica,sans-serif" font-weight="700" font-size="12.5" fill="#00C2A8">pay</text></svg>' },
        { n: 'Klarna', c: 'klarna', s: '<svg viewBox="0 0 56 18"><text x="28" y="14" font-family="Arial,Helvetica,sans-serif" font-weight="700" font-size="12.5" fill="#0A0B09" text-anchor="middle">Klarna</text></svg>' },
        { n: 'Zip', s: '<svg viewBox="0 0 40 18"><text x="20" y="14" font-family="Arial,Helvetica,sans-serif" font-weight="800" font-size="14" fill="#1A1A1A" text-anchor="middle">zip</text></svg>' }
      ];
      var wrap = document.createElement('div');
      wrap.id = 'coco-pay'; wrap.className = 'coco-pay';
      PAY.forEach(function (p) {
        var b = document.createElement('span');
        b.className = 'coco-pay-badge' + (p.c ? ' ' + p.c : '');
        b.setAttribute('aria-label', p.n); b.title = p.n; b.innerHTML = p.s;
        wrap.appendChild(b);
      });
      var anchor = document.getElementById('coco-atc-savings') || bb;
      anchor.parentNode.insertBefore(wrap, anchor.nextSibling);
    })();
  })();
  
  (function () {
    // Sticky bar "Create Now"
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest && e.target.closest('#foxdos_atc_button_trigger');
      if (!t) return;
      var box = document.getElementById('coco-cvb');
      if (!box) return;
      var r = box.getBoundingClientRect();
      if (r.top < 0 || r.bottom > (window.innerHeight || 800)) {
        e.preventDefault(); e.stopPropagation();
        setTimeout(function () { try { box.scrollIntoView({ block: 'start' }); } catch (_x) {} }, 20);
      }
    }, true);
  })();